export const ALERT_CLASS = {
	success: "alert-success",
	warning: "alert-warning",
	danger: "alert-danger",
	info: "alert-info"
};
export const FADE_IN = 300;
export const DELAY = 5000;
export const FADE_OUT = 400;
